/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, ReactElement } from 'react'
import { FieldHookConfig, useField } from 'formik'
import style from './EmailField.module.css'
import { Field } from '../../../Field/Field'
import { CustomError } from '../../../CustomError/CustomError'

type IEmailFieldProps = {
  label: string | ReactElement
  hasSmallMarginBottom?: boolean
  formatter?: (value: string) => string
  autocomplete?: string
  errorDataQaLocator?: string
  onBlurHandler?(e: React.ChangeEvent<HTMLInputElement>): void
  onChangeHandler?(e: React.ChangeEvent<HTMLInputElement>): void
  isBusy?: boolean
  wrapErrorText?: boolean
} & FieldHookConfig<string>

export const EmailField: FC<IEmailFieldProps> = ({ isBusy, ...props }) => {
  const [field, meta] = useField(props)

  return (
    <div className={style.emailField}>
      <Field
        {...props}
        className={style.field}
        errorRenderer={(error: string): ReactElement => (
          <CustomError error={error} touched={meta.touched} isBusy={isBusy} login={field.value} />
        )}
      />
    </div>
  )
}

EmailField.displayName = 'EmailField'
